import User from 'data/User';
import * as React from 'react';
import { listenToPlanChange } from 'state/Store';
import { postMessageToIosWrapperWithResponse } from 'utils';
import Subtitle from './components/Subtitle';
import { AppStorePlan } from './Order';

import firebase from 'firebase/app';
import 'firebase/database';

// const FooterView = styled.div`
//   margin: 0;
//   margin-top: 20px;
//   font-size: 14px;
//   color: rgba(var(--primary-fg-rgb), 0.7);
//   line-height: 16px;

//   a {
//     text-decoration: none;
//     ${hoverMixin('text-decoration: underline;')}
//   }
// `;

interface Props {
  user: User;
  storeProduct: AppStorePlan;
  onCancel: () => void;
}

export const WaitForAppStore: React.FC<Props> = props => {
  const { user, storeProduct, onCancel } = props;
  // const [isUpdatingPlan, setIsUpdatingPlan] = React.useState(false);
  const didCancel = React.useRef(false);

  const ref = React.useMemo(
    () => firebase.database().ref(`users/${user?.uid}`),
    [user]
  );
  const connection = React.useRef<any>(null);

  const disconnect = React.useCallback(() => {
    if (connection.current) {
      ref.off('value', connection.current);
      connection.current = null;
    }
  }, [connection]);

  const cancel = React.useCallback(() => {
    didCancel.current = true;
    disconnect();
    onCancel();
  }, [disconnect, onCancel]);

  // const openLinkAgain = React.useCallback(() => {
  //   window.open(checkoutLink, '_blank');
  // }, [checkoutLink]);

  React.useEffect(() => {
    // did mount
    listenToPlanChange();
    postMessageToIosWrapperWithResponse('buyPlan', {
      id: storeProduct.id
    }).then((success: boolean) => {
      if (success) {
        // setIsUpdatingPlan(true);
      } else {
        cancel();
      }
    });

    return () => {
      // did unmount
      disconnect();
    };
  }, []);

  // const footer: React.ReactNode =
  //   checkoutLink === undefined ? (
  //     'Generating link and opening window...'
  //   ) : (
  //     <>
  //       If the new window didn’t open,{' '}
  //       <a href="#" onClick={openLinkAgain}>
  //         click here
  //       </a>
  //       .
  //     </>
  //   );

  // if (isUpdatingPlan) {
  //   return (
  //     <div>
  //       <h1>Updating plan...</h1>
  //       <Subtitle style={{ maxWidth: 620 }}>
  //         Waiting for the purchase to be applied...
  //       </Subtitle>
  //     </div>
  //   );
  // }

  return (
    <div>
      <h1>Continue with Apple Pay</h1>
      <Subtitle style={{ maxWidth: 620 }}>
        Launching Apple Pay... Follow the instructions on your device.
      </Subtitle>
      <button
        className="large secondary"
        style={{ marginTop: 20 }}
        onClick={cancel}
      >
        Cancel
      </button>
      {/* <FooterView>{footer}</FooterView> */}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/buy/WaitForAppStore.tsx